import ApiClient from '../../loopback/apiClient';
import {
  AppThunk,
  FaerbungReivewActionTypes,
  FaerbungReviewMeta,
  SET_FAERBUNG_REVIEW_METAS,
  RESET_FAERBUNG_REVIEW_META,
  ADD_UPDATE_FAERBUNG_REVIEW_META,
  PartialBy,
  DELETE_FAERBUNG_REVIEW_META,
  SET_FAERBUNG_REVIEW_SCORE,
  FaerbungReviewScore,
  ADD_UPDATE_FAERBUNG_REVIEW_SCORE,
} from '../types';

export const setFaerbungReivewMetas = (
  payload: FaerbungReviewMeta[],
): FaerbungReivewActionTypes => ({
  type: SET_FAERBUNG_REVIEW_METAS,
  payload,
});

const addUpdateFaerbungReviewMetasRedux = (
  payload: FaerbungReviewMeta[],
): FaerbungReivewActionTypes => ({
  type: ADD_UPDATE_FAERBUNG_REVIEW_META,
  payload,
});

export const addUpdateFaerbungReviewMetas = (metas: PartialBy<FaerbungReviewMeta, 'id'>[]): AppThunk => async (dispatch): Promise<void> => {
  const updatedMetas = metas.map((m) => ApiClient.addOrUpdateFaerbungMeta(m));
  const fulfilledMetas = await Promise.all(updatedMetas);
  dispatch(addUpdateFaerbungReviewMetasRedux(fulfilledMetas));
};

export const fetchFaerbungReviewMetas = (
  surveyId: number,
): AppThunk => async (dispatch): Promise<void> => {
  const faerbungMetas = await ApiClient.getFaerbungReviewMeta(surveyId);
  dispatch(setFaerbungReivewMetas(faerbungMetas));
};

export const resetFaerbungReviewMetas = (): FaerbungReivewActionTypes => ({
  type: RESET_FAERBUNG_REVIEW_META,
});

const deleteFaerbungReviewMetaRedux = (payload: number): FaerbungReivewActionTypes => ({
  type: DELETE_FAERBUNG_REVIEW_META,
  payload,
});

export const deleteFaerbungReviewMeta = (
  id: number,
): AppThunk => async (dispatch): Promise<void> => {
  await ApiClient.deleteFaerbungMeta(id);
  dispatch(deleteFaerbungReviewMetaRedux(id));
};

const setFaerbungReviewScore = (payload: FaerbungReviewScore[]): FaerbungReivewActionTypes => ({
  type: SET_FAERBUNG_REVIEW_SCORE,
  payload,
});

export const fetchFaerbungReviewScores = (
  surveyId: number,
  enrollmentId: number,
): AppThunk => async (dispatch): Promise<void> => {
  const faerbungScores = await ApiClient.getFaerbungReviewScores(surveyId, enrollmentId);
  dispatch(setFaerbungReviewScore(faerbungScores));
};

const addUpdateFaerbungReviewScoreRedux = (
  payload: FaerbungReviewScore,
): FaerbungReivewActionTypes => ({
  type: ADD_UPDATE_FAERBUNG_REVIEW_SCORE,
  payload,
});

export const addUpdateFaerbungReviewScore = (fbScores: PartialBy<FaerbungReviewScore, 'id'>[]): AppThunk => async (dispatch): Promise<void> => {
  const updatedScores = await ApiClient.addOrUpdateFaerbungScores(fbScores);
  updatedScores.forEach((us) => dispatch(addUpdateFaerbungReviewScoreRedux(us)));
};
